





















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapServer } from '../../../src/api/installService';
import Sortable from 'sortablejs';
@Component({
  name: 'CustomPanel',
  components: {
  },
})
export default class CustomPanel extends Vue {
  @Prop() private complate: any;
  @Prop() private closeCustomPanel: any;
  @Prop() private showCustomPanel: any;
  private left: any = [];
  private leftL: number = 0;
  private right: any = ['Belong', 'MoneyType', 'Capital'];
  private rightL: number = 3;
  private mid: any = {
    Belong: '所属自贸区X1',
    EnterpriseType: '企业类型X1',
    WorkType: '行业类型X1',
    MoneyType: '贸易类型X1',
    Capital: '注册资本X1',
  };
  private mounted() {
    // const sortableLeft = new Sortable(document.getElementById('left_ul'), {
    //   ghostClass: 'blue-background-class',
    //   animation: 150,
    // });
    const sortableRight = new Sortable(document.getElementById('right_ul'), {
      ghostClass: 'blue-background-class',
      animation: 150,
    });
    mapServer.getScheme({
      type: 1,
    }).then((res: any) => {
      if (res.status === 200 && res.data && res.data.data && res.data.data.content) {
        const result = JSON.parse(res.data.data.content);
        this.left = result.left;
        this.leftL = result.left.length;
        // 处理加长面板
        if (this.left.includes('allEvents')) {
          this.leftL += 2;
        }
        this.right = result.right;
        this.rightL = result.right.length;
        // 处理加长面板
        if (this.right.includes('allEvents')) {
          this.rightL += 2;
        }
        const data = {
          left: this.left,
          right: this.right,
        };
        this.complate(data);
      } else {
        const obj = {
          left: this.left,
          right: this.right,
        };
        this.complate(obj);
      }
    });
  }
  // 获取图片地址
  private getImgUrl(icon: any) {
    return require('@/assets/img/customPanel/mini/' + icon + '.png');
  }
  private getImgUrl1(icon: any) {
    if (icon === 'allEvents') {
      icon += '3';
    }
    return require('@/assets/img/customPanel/mini/' + icon + '.png');
  }

  private goLeft(key: any, value: any) {
    if (this.leftL + value.split('X')[1] * 1 > 3) {
      this.$message('左侧板块已满！');
      return;
    }
    this.left.push(key);
    this.leftL += value.split('X')[1] * 1;
  }

  private goRight(key: any, value: any) {
    if (this.rightL + value.split('X')[1] * 1 > 3) {
      this.$message('右侧板块已满！');
      return;
    }
    this.right.push(key);
    this.rightL += value.split('X')[1] * 1;
  }

  private close_left_mini(item: any) {
    this.left = this.left.filter((it: any) => {
      return it !== item;
    });
    this.leftL = this.left.length;
  }

  private close_right_mini(item: any) {
    this.right = this.right.filter((it: any) => {
      return it !== item;
    });
    this.rightL = this.right.length;
  }

  private goComplate() {
    const left: any = [];
    const right: any = [];
    // $('#left_ul li').map((item: any) => {
    //   return left.push($('#left_ul li')[item].className);
    // });
    $('#right_ul li').map((item: any) => {
      return right.push($('#right_ul li')[item].className);
    });
    const data = {
      left,
      right,
    };
    this.complate(data);
    this.closeCustomPanel();
    mapServer.saveScheme({
      type: '1',
      content: JSON.stringify(data),
    });
  }
}
